/**
 * Runs zod state-shape validation only in development. In production the
 * caller's reducers are presumed correct; revalidating the entire schedule
 * (patients + nurses + chairs + invariant refinements) on every Redux action
 * costs ~10-50ms per dispatch on a real-sized day. The savings compound
 * during dialog interactions which dispatch many actions in quick succession.
 *
 * Errors thrown by the schema bubble up just like before, so dev still
 * catches shape regressions immediately.
 */
export const validateStateInDev = (schema, state) => {
	if (process.env.NODE_ENV === "development") {
		return schema.parse(state)
	}
	return state
}
